import React from 'react';

import { FormattedMessage } from 'react-intl';
import { all, call, put, takeEvery } from 'redux-saga/effects';

import * as actions from '@actions/upload';
import { fileUpload, preSignFile } from '@api/upload';
import types from '@constants/action-types';
import { toastError } from '@store/notifications';

export const getMimeTypeHack = file => {
  if (file.type === '') {
    if (file.name.endsWith('.xlsx')) {
      return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    }
  }

  return file.type;
};

export const handleUploadFilesRequest = function* ({ payload }) {
  try {
    const preAssignedData = new FormData();
    preAssignedData.append('file_name', payload.file.name);
    preAssignedData.append('content_type', getMimeTypeHack(payload.file));

    const response = yield call(preSignFile, preAssignedData);

    const postData = new FormData();
    const { key } = response.fields;
    Object.keys(response.fields).forEach(key => {
      postData.append(key, response.fields[key]);
    });
    postData.append('file', payload.file);

    const uploadResponse = yield call(fileUpload, {
      url: response.url,
      postData,
      onUploadProgress: payload.onUploadProgress,
    });

    yield call(payload.onSuccess, { ...uploadResponse, data: { ...uploadResponse.data, key } });
    yield put(actions.uploadFilesSuccess(uploadResponse));
  } catch (e) {
    yield put(
      toastError({
        id: 'file-upload-error',
        message: (
          <FormattedMessage
            defaultMessage="An unexpected error occurred, please try again."
            id="global.notification.api-error-default"
          />
        ),
      })
    );
    yield put(actions.uploadFilesFailure(e));
  }
};

export default all([takeEvery(types.UPLOAD_FILES_REQUEST, handleUploadFilesRequest)]);
